// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/dealer-analytics/missed/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/dealer-analytics/missed/")({
  component: PageComponent,

})

function PageComponent() {
  return <Page />
}
